package fr.frux.core.designsystem.format

import kotlin.math.roundToInt

/**
 * Distance affichable, en français.
 *
 * Vit ici, et pas dans chaque écran, parce que chacun le refaisait à sa façon : la carte et
 * l'écran Favoris concaténaient tous deux des mètres bruts, ce qui donnait « à 45417 m » pour un
 * arbre à 45 km.
 *
 * Le seuil et la précision suivent l'usage de cueillette : sous le kilomètre on marche et le
 * mètre parle, au-delà c'est un trajet et une décimale suffit, passé dix kilomètres même la
 * décimale est du bruit.
 */
fun formatDistance(meters: Double): String {
    val safe = meters.coerceAtLeast(0.0)
    val km = safe / METERS_IN_KM
    return when {
        safe < METERS_IN_KM -> "${safe.roundToInt()} m"
        km >= WHOLE_KM_THRESHOLD -> "${km.roundToInt()} km"
        else -> formatKmWithTenth(km)
    }
}

/**
 * Dixièmes entiers plutôt qu'un format à virgule flottante : `toString()` traîne des décimales
 * parasites (1250 / 1000.0 rend « 1.25 »), et les formateurs de la plateforme ne sont pas communs
 * aux cibles KMP.
 */
private fun formatKmWithTenth(km: Double): String {
    val tenths = (km * 10).roundToInt()
    val whole = tenths / 10
    val decimal = tenths % 10
    return if (decimal == 0) "$whole km" else "$whole,$decimal km"
}

private const val METERS_IN_KM = 1000.0

/** Au-delà, la décimale n'aide plus à décider si on y va. */
private const val WHOLE_KM_THRESHOLD = 10.0
